/**
 * Les Parisiennes — Product Card Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 9. PRODUCT VARIANT SWITCHING
   * ============================================================ */

  /* Product card image navigation (arrows) */
  window.cardImageNav = function (btn, dir) {
    var media = btn.closest('.product-card__media');
    if (!media) return;
    var imgs = media.querySelectorAll('.product-card__img');
    if (imgs.length < 2) return;
    var currentIndex = 0;
    imgs.forEach(function (img, i) { if (img.classList.contains('is-active')) currentIndex = i; });
    imgs[currentIndex].classList.remove('is-active');
    var next = (currentIndex + dir + imgs.length) % imgs.length;
    imgs[next].classList.add('is-active');
  };
  function initProductCardReveal() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function (c) { c.classList.add('is-revealed'); });
      return;
    }
    /* Appear only — cards show once and stay */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
        }
      });
    }, { threshold: 0.08, rootMargin: '60px 0px -20px 0px' });
    cards.forEach(function (card) { observer.observe(card); });
  }

  /* ============================================================
   * 27b. PRODUCT CARD HOVER IMAGE SWAP
   * ============================================================ */
  function initProductCardHover() {
    if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    document.addEventListener('mouseover', function (e) {
      var media = e.target.closest('.product-card__media');
      if (!media) return;
      if (e.relatedTarget && media.contains(e.relatedTarget)) return;
      var imgs = media.querySelectorAll('.product-card__img');
      if (imgs.length < 2) return;
      imgs.forEach(function (img) { img.classList.remove('is-active'); });
      imgs[1].classList.add('is-active');
    });

    document.addEventListener('mouseout', function (e) {
      var media = e.target.closest('.product-card__media');
      if (!media) return;
      if (e.relatedTarget && media.contains(e.relatedTarget)) return;
      var imgs = media.querySelectorAll('.product-card__img');
      if (!imgs.length) return;
      /* Always reset to first image on leave */
      imgs.forEach(function (img, i) { img.classList.toggle('is-active', i === 0); });
    });
  }

  registerInit('initProductCardReveal', initProductCardReveal);
  registerInit('initProductCardHover', initProductCardHover);
}());
